// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"529":"1e842390","532":"64530d1d","801":"ff7a0068"}[chunkId] + ".chunk.js";
};